import { useEffect } from 'react';

/**
 * SEO Component for dynamically updating meta tags
 * Usage: <SEO title="Page Title" description="Page description" />
 */
const SEO = ({ 
    title = "The Daily Comp - Daily Word Challenges & Multiplayer Competitions",
    description = "Join the ultimate daily word challenge platform! Compete with friends in Scrabble, Pokémon, Countries, and custom themed word games. Create private tournaments, climb leaderboards, and claim the golden pencil.",
    keywords = "daily word games, word challenges, multiplayer word games, scrabble competitions, vocabulary games",
    image = "https://thedailycomp.com/logo180_2.png",
    url = "https://thedailycomp.com/",
    type = "website"
}) => {
    useEffect(() => {
        // Update document title
        document.title = title;

        // Update or create meta tags
        const updateMetaTag = (property, content, isProperty = false) => {
            const attribute = isProperty ? 'property' : 'name';
            let element = document.querySelector(`meta[${attribute}="${property}"]`);
            
            if (!element) {
                element = document.createElement('meta');
                element.setAttribute(attribute, property);
                document.head.appendChild(element);
            }
            
            element.setAttribute('content', content);
        };

        // Standard meta tags
        updateMetaTag('description', description);
        updateMetaTag('keywords', keywords);

        // Open Graph tags
        updateMetaTag('og:title', title, true);
        updateMetaTag('og:description', description, true);
        updateMetaTag('og:image', image, true);
        updateMetaTag('og:url', url, true);
        updateMetaTag('og:type', type, true);

        // Twitter tags
        updateMetaTag('twitter:title', title, true);
        updateMetaTag('twitter:description', description, true);
        updateMetaTag('twitter:image', image, true);
        updateMetaTag('twitter:url', url, true);

        // Update canonical link
        let canonical = document.querySelector('link[rel="canonical"]');
        if (!canonical) {
            canonical = document.createElement('link');
            canonical.setAttribute('rel', 'canonical');
            document.head.appendChild(canonical);
        }
        canonical.setAttribute('href', url);

    }, [title, description, keywords, image, url, type]);

    return null; // This component doesn't render anything
};

export default SEO;
